module.exports = __webpack_public_path__ + "static/media/external_link.11b1cd05.svg";